function ShowMoreContent() {
  // Select all text sections
  const textSections = document.querySelectorAll('.show-more-text');

  textSections.forEach((section) => {
    const excerpt = section.querySelector('.excerpt');
    const hiddenContent = section.querySelector('.more-text');
    const toggleButton = section.querySelector('.show-more-button');
    const dots = section.querySelector('.more-dots');

    // Initially hide the hidden content
    hiddenContent.style.display = 'none';

    // Toggle function
    toggleButton.addEventListener('click', () => {
      if (hiddenContent.style.display === 'none') {
        hiddenContent.style.display = 'block';
        toggleButton.textContent = 'Show less';
        toggleButton.classList.add("less");
        dots.style.display = 'none'; // Hide dots when expanded
      } else {
        hiddenContent.style.display = 'none';
        toggleButton.textContent = 'Show more';
        toggleButton.classList.remove("less");
        dots.style.display = 'inline'; // Show dots when collapsed
      }
    });
  });
}

// Call the function when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', ShowMoreContent);